import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const toneMap = {
  dodgers: { bg: "bg-dodgers", text: "text-galactico" },
  lime: { bg: "bg-lime", text: "text-dodgers" },
  mandrogni: { bg: "bg-mandrogni", text: "text-galactico" },
  wimbledon: { bg: "bg-wimbledon", text: "text-dodgers" },
  spalding: { bg: "bg-spalding", text: "text-galactico" },
  lakers: { bg: "bg-lakers", text: "text-galactico" },
  settebello: { bg: "bg-settebello", text: "text-galactico" },
  "rosso-enzo": { bg: "bg-rosso-enzo", text: "text-galactico" },
  "light-blue-god": { bg: "bg-light-blue-god", text: "text-galactico" },
  nadia: { bg: "bg-nadia", text: "text-dodgers" },
};

const Pattern = ({ tone }) => {
  const fill = tone === "lime" || tone === "wimbledon" || tone === "nadia" ? "#003143" : "#ffffff";
  return (
    <svg viewBox="0 0 200 130" className="absolute inset-0 w-full h-full opacity-[0.18]" preserveAspectRatio="none" aria-hidden="true">
      <g stroke={fill} strokeWidth="0.8" fill="none">
        {Array.from({ length: 14 }).map((_, i) => (
          <line key={i} x1={i * 16} y1="0" x2={i * 16 - 40} y2="130" />
        ))}
      </g>
      <circle cx="160" cy="40" r="32" stroke={fill} strokeWidth="1" fill="none" />
    </svg>
  );
};

const CaseStudyCard = ({ title, category, kpis = [], tone = "dodgers", to = "/works", image, testId }) => {
  const t = toneMap[tone] || toneMap.dodgers;
  return (
    <Link
      to={to}
      className={`relative flex flex-col p-6 md:p-8 pb-7 md:pb-9 ${t.bg} ${t.text} group overflow-hidden min-h-[380px] md:min-h-[420px] lg:min-h-[440px]`}
      data-testid={testId}
      data-hover="true"
    >
      {image ? (
        <>
          <img
            src={image}
            alt={title}
            className="absolute inset-x-0 top-0 w-full h-[50%] md:h-[55%] object-cover opacity-55 group-hover:opacity-70 transition-opacity duration-500"
            decoding="async"
            draggable="false"
          />
          <span
            className="absolute inset-0 bg-gradient-to-t from-dodgers via-dodgers/95 to-transparent"
            style={{ backgroundImage: "linear-gradient(to top, rgba(0,49,67,0.98) 50%, rgba(0,49,67,0.7) 70%, rgba(0,49,67,0) 100%)" }}
            aria-hidden="true"
          />
        </>
      ) : (
        <Pattern tone={tone} />
      )}
      <div className="relative z-10 flex flex-col h-full flex-1 justify-between gap-6">
        <span className="font-condensed uppercase tracking-widest text-xs md:text-sm opacity-90">
          {category}
        </span>
        <div>
          <h3 className="font-display text-[1.5rem] md:text-[1.85rem] leading-[1.05] mb-4 md:mb-5 max-w-[18ch]">
            {title}
          </h3>
          <ul className="space-y-1.5">
            {kpis.map((k, i) => (
              <li key={i} className="text-[14px] md:text-[15px] font-semibold leading-snug">
                {k}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <ArrowUpRight size={22} className="absolute top-6 right-6 z-10 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
    </Link>
  );
};

export default CaseStudyCard;
